import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$videoType = this.el.dataset.videoType
        this.$progress = this.$('progress')[0]
        this.$range = this.$('range')[0]
        this.$video = this.$('video')[0]
        this.$cta = this.$('cta')[0]

        this.events = {
            click: {
                play: 'onPlayClick',
                fullscreen: 'onFullScreenClick',
                mute: 'onMuteClick',
                video: 'onPlayClick',
                cta: 'onPlayClick'
            },
            input: {
                range: 'onRangeChange'
            }
        }
    }

    init() {
        if (typeof this.$video !== 'undefined') {
            this.onVideoTimeUpdateBind = this.onVideoTimeUpdate.bind(this);
            this.$video.addEventListener('timeupdate', this.onVideoTimeUpdateBind);

            this.eventsRequiringUIUpdate = 'play playing pause ended'.split(' ')
            this.updateUIBind = this.updateUI.bind(this);
            for(let event of this.eventsRequiringUIUpdate) {
                this.$video.addEventListener(event, this.updateUIBind);
            }

            this.onVideoEndedBind = this.onVideoEnded.bind(this);
            this.$video.addEventListener('ended', this.onVideoEndedBind)

            document.addEventListener("fullscreenchange", this.onFullScreenChange = () => {
                this.updateUI();
            });
        }
    }

    play() {
        this.$video.play();
    }

    onPlayClick() {
        // console.log('play toggle');
        if(this.$video.paused) this.$video.play()
        else this.$video.pause()
    }

    onFullScreenClick() {
        // console.log('fullscreen toggle');
        if (!document.fullscreenElement) {
              this.el.requestFullscreen ? this.el.requestFullscreen() : this.$video.webkitEnterFullScreen();
        } else if(document.exitFullscreen) {
              document.exitFullscreen();
        }
    }

    onMuteClick() {
        // console.log('mute toggle');
        this.$video.muted = !this.$video.muted;

        this.updateUI();
    }

    onVideoTimeUpdate() {
        // console.log('progress');
        // this.$range.value = this.$video.currentTime / this.$video.duration
        this.updateProgressBar();
    }

    onVideoEnded() {
        this.reset()
    }

    onRangeChange() {
        this.$video.currentTime = this.$range.value * this.$video.duration;
    }

    updateProgressBar() {
        if(this.$video.duration)
            this.$range.value = this.$video.currentTime / this.$video.duration;
        else
            this.$range.value = 0;

        this.$progress.style.setProperty('--progress', this.$range.value)
    }

    updateUI() {
        this.updateProgressBar();

        this.el.classList.toggle('is-playing', !this.$video.paused)
        this.el.classList.toggle('is-muted', this.$video.muted)
        this.el.classList.toggle('is-fullscreen', document.fullscreenElement == this.el)
    }

    reset() {
        if (this.$videoType == 'vimeo' || this.$videoType == 'youtube') {
            let $iframe = this.$('iframe')[0];
            let vidsrc = $iframe.src;

            $iframe.src = '';
            $iframe.src = vidsrc;
        } else {
            this.$video.autoplay = false;
            this.$video.load();
            this.updateUI();
        }
    }

    destroy() {
        this.$video?.removeEventListener('timeupdate', this.onVideoTimeUpdateBind);
        if(this.eventsRequiringUIUpdate) {
            for(let event of this.eventsRequiringUIUpdate) {
                this.$video?.removeEventListener(event, this.updateUIBind);
            }
        }
        this.$video?.removeEventListener('ended', this.onVideoEndedBind)

        document.removeEventListener("fullscreenchange", this.onFullScreenChange)
    }
}
